import type { FormEvent, ReactNode } from "react";
import { createPortal } from "react-dom";
import { Loader2, X } from "lucide-react";
import { Button } from "@/components/ui/button";

export const BORDER = { borderColor: "hsl(210,30%,85%)" };

export function FormDrawer({
  title,
  onClose,
  onSubmit,
  error,
  busy,
  children,
}: {
  title: string;
  onClose: () => void;
  onSubmit: (e: FormEvent) => void;
  error: string | null;
  busy: boolean;
  children: ReactNode;
}) {
  return createPortal(
    <>
      <div className="fixed inset-0 z-[9998] bg-black/30" onClick={onClose} />
      <div
        className="fixed right-0 top-0 z-[9999] flex h-full w-[500px] flex-col border-l bg-white shadow-xl"
        style={BORDER}
      >
        <div className="flex items-center justify-between border-b px-6 py-4" style={BORDER}>
          <h2 className="text-lg font-semibold text-foreground">{title}</h2>
          <button
            type="button"
            onClick={onClose}
            className="flex h-7 w-7 items-center justify-center rounded text-muted-foreground hover:bg-[hsl(210,50%,96%)]"
          >
            <X className="h-4 w-4" strokeWidth={1.5} />
          </button>
        </div>
        <form onSubmit={onSubmit} className="flex flex-1 flex-col overflow-y-auto">
          <div className="flex-1 space-y-4 p-6">
            {error && (
              <div className="rounded-md border border-destructive/40 bg-destructive/5 px-3 py-2 text-xs text-destructive">
                {error}
              </div>
            )}
            {children}
          </div>
          <div className="flex justify-end gap-2 border-t px-6 py-4" style={BORDER}>
            <Button type="button" variant="outline" onClick={onClose}>
              Cancel
            </Button>
            <Button type="submit" disabled={busy}>
              {busy && <Loader2 className="h-4 w-4 animate-spin" strokeWidth={1.5} />}
              Save
            </Button>
          </div>
        </form>
      </div>
    </>,
    document.body,
  );
}
